//Кол-во отображающихся следующих слайдов
export const NEXT_VISIBLE_CARDS_COUNT = 2;

//Значение в пикселях, на которое смещается вправо каждый следующий слайд
export const PER_SLIDE_OFFSET = 12;
